<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Add Custom Service</p>
            </header>

            <section class="modal-card-body">
                <o-field label="Title" :type="fieldType('title')" :message="getError('title')">
                    <o-input v-model="copy.title" placeholder="Title"/>
                </o-field>

                <o-field label="Description" :type="fieldType('description')" :message="getError('description')">
                    <o-input v-model="copy.description" placeholder="Description" maxlength="200" type="textarea"/>
                </o-field>

                <o-field label="Price" :type="fieldType('price')" :message="getError('price')">
                    <o-input v-model="copy.price"/>
                </o-field>
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button @click.prevent="handleSubmit" v-submit="submitting" class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import HandlesForm from '../../mixins/HandlesForm'

    export default {
        mixins: [HandlesForm],

        data () {
            return {
                copy: null
            }
        },

        mounted () {
            this.copy = {
                project_id: this.currentProjectId,
                title: '',
                description: '',
                price: null,
                type: 'custom',
                reimbursable: true,
                source_id: this.currentProjectId,
                source_type: 'project'
            }
        },

        computed: {
            ...mapGetters({
                currentProjectId: 'currentProjectId',
            })
        },

        methods: {
            ...mapActions(['createProjectService']),

            handleSubmit() {
                let submit = this.wrapSubmit(this.createProjectService)

                submit(this.copy)
                    .then(res => {
                        this.successMessage('Project Custom Service created')
                        this.$parent.$parent.$emit('update:active', false)
                        return res
                    })
            }
        }
    }
</script>
